import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'LINEARREG_INTERCEPT',
  version: 1,
  label: 'Linear Regression Intercept',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 61,
  inputs: [period('timeperiod', 14)],
  outputs: [line('intercept', 'Intercept', COLOR.blue)],
  talib: { functions: ['LINEARREG_INTERCEPT'], expr: 'LINEARREG_INTERCEPT(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
